














































































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class QuickStart extends Vue {
  toggleZoom (evt: MouseEvent) {
    const anchor = evt.composedPath().find((node: EventTarget) => {
      return (node as Element).className.includes('figure')
    }) as Element
    const wasZoomed = anchor.className.includes('zoomed')

    this.closeAllImages()

    if (wasZoomed) {
      return
    }

    anchor.classList.add('zoomed')
  }

  private closeAllImages () {
    Array.from(document.querySelectorAll('.figure'))
      .forEach(el => el.classList.remove('zoomed'))
  }
}
